import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "@/components/ui";
import { SettlementStepCard, type StepCardProps } from "../SettlementStepCard";

export function CommissionInvoiceStep({
  busy,
  noSelection,
  submitting,
  invoiceableCents,
  onMarkInvoiced,
  disabled = false,
  ...card
}: StepCardProps & {
  busy: boolean;
  noSelection: boolean;
  submitting: boolean;
  invoiceableCents: number;
  /** Rejects when the action failed; the form is then kept for a retry. */
  onMarkInvoiced: (note?: string) => Promise<void>;
  disabled?: boolean;
}) {
  const { t } = useTranslation("payments");
  const [note, setNote] = useState("");
  const formDisabled = disabled || busy || noSelection || invoiceableCents <= 0;

  const handleSubmit = async () => {
    try {
      await onMarkInvoiced(note.trim() || undefined);
      setNote("");
    } catch {
      /* toast via mutation onError; keep the form so the operator can retry */
    }
  };

  return (
    <SettlementStepCard
      {...card}
      title={t("settlements.detail.steps.invoiceTitle")}
      description={t("settlements.detail.steps.invoiceDesc")}
      disabled={formDisabled}
    >
      <div className="space-y-3">
        <Input
          value={note}
          onChange={(e) => setNote(e.target.value)}
          disabled={formDisabled}
          placeholder={t("settlements.detail.invoiceNotePlaceholder")}
          aria-label={t("settlements.detail.invoiceNotePlaceholder")}
        />
        <Button
          type="button"
          className="w-full"
          disabled={formDisabled}
          isLoading={submitting}
          onClick={() => void handleSubmit()}
        >
          {t("settlements.detail.markInvoiced")}
        </Button>
      </div>
    </SettlementStepCard>
  );
}
